import EditCollectionURNModal from './EditCollectionURNModal.container'
export default EditCollectionURNModal
